import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["disabled"];
const _hoisted_2 = { class: "flex-1 truncate" };
const _hoisted_3 = ["disabled", "onClick"];
const _hoisted_4 = { class: "flex-1 truncate" };
const _hoisted_5 = {
    key: 1,
    class: "c-inp-error-message text-body-6 mt-4"
};
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { clsx } from 'clsx';
// Props & Emits
export default /*@__PURE__*/ _defineComponent({
    __name: 'Dropdown',
    props: {
        menuItems: {},
        placeholder: { default: 'Dropdown' },
        disabled: { type: Boolean, default: false },
        modelValue: { default: '' },
        error: { type: Boolean },
        errorMessage: {}
    },
    emits: ["update:modelValue", "select"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // Reactive state
        const isOpen = ref(false);
        const dropdownRef = ref();
        const triggerRef = ref();
        // Computed
        const selectedItem = computed(() => {
            if (!props.modelValue)
                return null;
            return props.menuItems.find((item) => item.id === props.modelValue) || null;
        });
        const displayText = computed(() => {
            if (selectedItem.value) {
                return selectedItem.value.text;
            }
            return props.placeholder;
        });
        // Methods
        function toggleDropdown() {
            if (props.disabled)
                return;
            isOpen.value = !isOpen.value;
        }
        function selectItem(item) {
            if (item.disabled)
                return;
            emit('update:modelValue', item.id);
            emit('select', item);
            isOpen.value = false;
        }
        function handleClickOutside(event) {
            if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
                isOpen.value = false;
            }
        }
        // Lifecycle
        onMounted(() => {
            document.addEventListener('click', handleClickOutside);
        });
        onUnmounted(() => {
            document.removeEventListener('click', handleClickOutside);
        });
        // Styles
        const styles = {
            container: clsx('relative inline-block w-full'),
            trigger: clsx('flex items-center justify-between w-full px-16 py-12 text-left bg-white border-1 border-gray-250 text-gray-900 rounded-6 cursor-pointer transition-all duration-200 text-body-5', 'desktop:rounded-8 desktop:text-body-4'),
            triggerDisabled: clsx('disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed disabled:hover:border-gray-250 disabled:hover:text-gray-400'),
            chevron: clsx('w-16 h-16 transition-transform duration-200'),
            chevronOpen: clsx('transform rotate-180'),
            dropdown: clsx('absolute top-full left-0 right-0 mt-4 bg-white border-1 border-gray-250 rounded-8 shadow-lg z-50 overflow-hidden', 'animate-in fade-in-0 zoom-in-95 duration-100'),
            dropdownList: clsx('py-4 max-h-200 overflow-y-auto'),
            menuItem: clsx('w-full flex items-center px-16 py-12 text-left cursor-pointer transition-colors duration-150 border-none bg-transparent'),
            menuItemDefault: clsx('text-gray-900 hover:bg-gray-50 hover:text-blue-600'),
            menuItemSelected: clsx('bg-blue-50 text-blue-600'),
            menuItemDisabled: clsx('text-gray-400 cursor-not-allowed'),
            stateLabel: clsx('text-xs text-purple-500 font-medium'),
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "dropdownRef",
                ref: dropdownRef,
                class: _normalizeClass(styles.container)
            }, [
                _createElementVNode("button", {
                    ref_key: "triggerRef",
                    ref: triggerRef,
                    type: "button",
                    class: _normalizeClass([
                        styles.trigger,
                        {
                            [styles.triggerDisabled]: props.disabled,
                        },
                        props.error ? 'c-inp-error' : '',
                    ]),
                    disabled: props.disabled,
                    onClick: toggleDropdown
                }, [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(displayText.value), 1),
                    (_openBlock(), _createElementBlock("svg", {
                        class: _normalizeClass([
                            styles.chevron,
                            {
                                [styles.chevronOpen]: isOpen.value && !props.disabled,
                            },
                        ]),
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                    }, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 9l-7 7-7-7"
                            }, null, -1)
                        ]))], 2))
                ], 10, _hoisted_1),
                (isOpen.value && !props.disabled)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(styles.dropdown)
                    }, [
                        _createElementVNode("ul", {
                            class: _normalizeClass(styles.dropdownList)
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuItems, (item) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: item.id
                                }, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        disabled: item.disabled,
                                        class: _normalizeClass([
                                            styles.menuItem,
                                            {
                                                [styles.menuItemSelected]: selectedItem.value?.id === item.id && !item.disabled,
                                                [styles.menuItemDisabled]: item.disabled,
                                                [styles.menuItemDefault]: selectedItem.value?.id !== item.id && !item.disabled,
                                            },
                                        ]),
                                        onClick: ($event) => (selectItem(item))
                                    }, [
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(item.text), 1)
                                    ], 10, _hoisted_3)
                                ]));
                            }), 128))
                        ], 2)
                    ], 2))
                    : _createCommentVNode("", true),
                (props.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(props.errorMessage), 1))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
